import front from '@/../static/js/proto/CtpFront';
import * as utils from '@/utils/utils';
import model from "@/../static/js/proto/Model.js";
/**
 * 取消订阅的函数集合
 */
const unSubFuns = {
  /**
   * 未触发条件单
   */
  conditionNotTriggerList(list: any[]) {
    list.splice(0, list.length);
    front.conditionOrderUnsub('condition_order');
  },
  capital(obj) {
    obj.rights = 0.0;
    obj.usable = 0.0;
    obj.profitAloss = 0.0;
    obj.desirable = 0.0;
    obj.account = 0.0;
    model.trader.queryCapital.stop();

  }
};
export default unSubFuns;



// WEBPACK FOOTER //
// ./src/store/sub-utils/unsubfuns.ts